// @flow
// Manages attribute table display
import * as actionTypes from '../constants/action_types'
import { getLayer } from '../utils'

export type AttributeTableType = {
    geometry: {
        // geojson
        coordinates: [],
        type: string,
    },
    header: string[],
    id: string,
    properties: {
        [key]: string | number,
    },
    schema: {
        geometry?: string,
        properties: {
            [key]: string | number,
        }
    },
    // should be Feature
    type: string,

    // unique identifier
    key: string,
    layerName: string,
    mapsourceName: string,
    // Data source query
    queryURL: string,
    querying: boolean,
}

export type ActionType = {
    // Add an attribute table to the display list.
    attributeTable?: AttributeTableType,
    key?: string,
}

export type AttributeTablesType = {
    attributeTables: AttributeTableType[],
}

const initialState = {
    // All the open attribute tables
    attributeTables: [],
}

export default function attributeTables(state: AttributeTablesType = initialState, action: ActionType) {
    let ret = state

    if (action.type === actionTypes.ATTRIBUTE_TABLE_SHOW) {
        let key = action.attributeTable.key
        if (!key) {
            key = `${action.attributeTable.mapsourceName}:${action.attributeTable.layerName}`
        }
        const dups = state.attributeTables.filter(a => a.key === key)
        if (dups.length === 0) {
            // Update key
            ret = { ...state, attributeTables: [...state.attributeTables, { ...action.attributeTable, key }] }
        }
    } else if (action.type === actionTypes.ATTRIBUTE_TABLE_HIDE) {
        const itable = state.attributeTables.findIndex(a => a.key === action.key)
        if (itable >= 0) {
            // Remove from list
            ret = { ...state, attributeTables: [...state.attributeTables.slice(0, itable), ...state.attributeTables.slice(itable + 1)] }
        }
    } else if (action.type === actionTypes.USER_LAYER_DELETE) {
        // Check if this layer is displayed
        const key = `${action.mapsourceName}:${action.layerName}`
        const itable = state.attributeTables.findIndex(a => a.key === key)
        if (itable >= 0) {
            // Remove from list
            ret = { ...state, attributeTables: [...state.attributeTables.slice(0, itable), ...state.attributeTables.slice(itable + 1)] }
        }
    } else if (action.type === actionTypes.SET_QUERYING) {
        const key = `${action.attributeTable.mapsourceName}:${action.attributeTable.layerName}`
        const itable = state.attributeTables.findIndex(a => a.key === key)
        ret = {
            ...state,
            attributeTables: [
                ...state.attributeTables.slice(0, itable),
                { ...action.attributeTable },
                ...state.attributeTables.slice(itable + 1),
            ],
        }
    }

    return ret
}
